if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        
        // Add navigation arrow event listeners
        this.setupNavigationArrows();
        
        // Add keyboard navigation
        this.setupKeyboardNavigation();
        
        // Initialize navigation counter
        setTimeout(() => {
          this.updateNavigationCounterFromActive();
        }, 100);
        
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      setupNavigationArrows() {
        const navArrows = this.querySelectorAll('.gallery-nav-arrow');
        navArrows.forEach(arrow => {
          arrow.addEventListener('click', (e) => {
            e.preventDefault();
            const direction = arrow.dataset.direction;
            this.navigateMedia(direction);
          });
        });
      }

      setupKeyboardNavigation() {
        // Add keyboard event listener to the media gallery
        this.addEventListener('keydown', (e) => {
          // Only handle if the gallery or one of its elements is focused
          if (!this.contains(document.activeElement)) return;
          
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            this.navigateMedia('prev');
          } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            this.navigateMedia('next');
          }
        });

        // Make the gallery focusable for keyboard navigation
        if (!this.hasAttribute('tabindex')) {
          this.setAttribute('tabindex', '0');
        }
      }

      navigateMedia(direction) {
        // Get colors from the currently selected bundle only
        const selectedColors = new Set();
        
        // Find which bundle deal is actually selected
        const checkedInput = document.querySelector('input[name*="kaching-bundles-deal"]:checked');
        let selectedBundleBar = null;
        let bundleMode = 'Unknown';
        
        if (checkedInput) {
          // Get the selected bundle bar
          selectedBundleBar = document.querySelector(`[data-deal-bar-id="${checkedInput.value}"]`);
          
          if (selectedBundleBar) {
            // Determine bundle mode based on number of swatch groups in selected bar
            const swatchGroupsInSelectedBar = selectedBundleBar.querySelectorAll('.kaching-bundles__swatch-buttons');
            bundleMode = swatchGroupsInSelectedBar.length > 1 ? 'Buy 2' : 'Single';
            
            // Get colors only from the selected bundle bar
            swatchGroupsInSelectedBar.forEach(group => {
              const selectedSwatch = group.querySelector('.kaching-bundles__swatch-buttons__button--selected');
              if (selectedSwatch) {
                const color = selectedSwatch.getAttribute('title');
                if (color) selectedColors.add(color.toLowerCase());
              }
            });
          }
        }
        
        if (selectedColors.size === 0) {
          console.log('❌ No colors selected, cannot navigate');
          return;
        }
        
        const currentActive = this.elements.viewer.querySelector('[data-media-id].is-active');
        if (!currentActive) {
          console.log('❌ No current active media found');
          return;
        }

        const allMediaItems = Array.from(this.elements.viewer.querySelectorAll('[data-media-id]'));
        // Filter to only template-prefixed media items (main media elements, not duplicates)
        const templateMediaItems = allMediaItems.filter(item => {
          return item.dataset.mediaId.includes('template--');
        });
        

        
        // Get all media items matching ANY of the selected colors (for navigation)
        const variantMediaItems = templateMediaItems.filter(item => {
          const img = item.querySelector('img');
          if (!img || !img.alt) return false;
          
          const altText = img.alt.toLowerCase();
          const words = altText.split(/\s+/);
          
          // Check if image alt text contains ANY of the selected colors
          return [...selectedColors].some(color => words.includes(color));
        });
        
        if (variantMediaItems.length <= 1) {
          return;
        }

        const currentIndex = variantMediaItems.findIndex(item => item === currentActive);
        
        let nextIndex;

        if (direction === 'next') {
          nextIndex = currentIndex + 1 >= variantMediaItems.length ? 0 : currentIndex + 1;
        } else {
          nextIndex = currentIndex - 1 < 0 ? variantMediaItems.length - 1 : currentIndex - 1;
        }
        
        const nextMedia = variantMediaItems[nextIndex];
        
        if (nextMedia) {
          
          // Clear any manual style overrides to let the normal system work
          this.clearManualStyles();
          
          // Temporarily make the target media visible for navigation
          nextMedia.style.display = '';
          nextMedia.classList.remove('hidden');
          
          // Let the normal setActiveMedia handle the visibility
          this.setActiveMedia(nextMedia.dataset.mediaId, false);
          this.updateNavigationCounter(nextIndex + 1, variantMediaItems.length);
        }
      }

      clearManualStyles() {
        // Clear any manual style overrides on all media items to avoid conflicts
        const allMediaItems = Array.from(this.elements.viewer.querySelectorAll('[data-media-id]'));
        allMediaItems.forEach(item => {
          // Only clear styles if they were manually set by our navigation
          if (item.style.display === 'none' || item.style.display === 'list-item') {
            item.style.display = '';
          }
        });
      }

      updateNavigationCounter(current, total) {
        const counterCurrent = this.querySelector('.slider-counter--current');
        const counterTotal = this.querySelector('.slider-counter--total');
        
        if (counterCurrent) counterCurrent.textContent = current;
        if (counterTotal) counterTotal.textContent = total;
        
        // Show/hide navigation arrows based on number of visible items
        this.updateNavigationVisibility(total);
      }

      updateNavigationVisibility(visibleCount) {
        const navArrows = this.querySelectorAll('.gallery-nav-arrow');
        const sliderCounter = this.querySelector('.slider-counter');
        
        if (visibleCount <= 1) {
          navArrows.forEach(arrow => arrow.style.display = 'none');
          if (sliderCounter) sliderCounter.style.display = 'none';
        } else {
          navArrows.forEach(arrow => arrow.style.display = 'flex');
          if (sliderCounter) sliderCounter.style.display = 'block';
        }
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
        this.updateNavigationCounterFromActive();
      }

      updateNavigationCounterFromActive() {
        const currentActive = this.elements.viewer.querySelector('[data-media-id].is-active');
        if (!currentActive) return;

        // Get colors from the currently selected bundle only
        const selectedColors = new Set();
        
        // Find which bundle deal is actually selected
        const checkedInput = document.querySelector('input[name*="kaching-bundles-deal"]:checked');
        let selectedBundleBar = null;
        
        if (checkedInput) {
          // Get the selected bundle bar
          selectedBundleBar = document.querySelector(`[data-deal-bar-id="${checkedInput.value}"]`);
          
          if (selectedBundleBar) {
            // Get colors only from the selected bundle bar
            const swatchGroupsInSelectedBar = selectedBundleBar.querySelectorAll('.kaching-bundles__swatch-buttons');
            swatchGroupsInSelectedBar.forEach(group => {
              const selectedSwatch = group.querySelector('.kaching-bundles__swatch-buttons__button--selected');
              if (selectedSwatch) {
                const color = selectedSwatch.getAttribute('title');
                if (color) selectedColors.add(color.toLowerCase());
              }
            });
          }
        }
        
        if (selectedColors.size === 0) return;

        const allMediaItems = Array.from(this.elements.viewer.querySelectorAll('[data-media-id]'));
        // Filter to only template-prefixed media items (main media elements, not duplicates)
        const templateMediaItems = allMediaItems.filter(item => {
          return item.dataset.mediaId.includes('template--');
        });
        
        // Get all media items matching ANY of the selected colors
        const variantMediaItems = templateMediaItems.filter(item => {
          const img = item.querySelector('img');
          if (!img || !img.alt) return false;
          
          const altText = img.alt.toLowerCase();
          const words = altText.split(/\s+/);
          
          return [...selectedColors].some(color => words.includes(color));
        });

        const currentIndex = variantMediaItems.findIndex(item => item === currentActive);
        if (currentIndex !== -1) {
          this.updateNavigationCounter(currentIndex + 1, variantMediaItems.length);
        }
      }

      setActiveMedia(mediaId, prepend) {
        // Clear any manual style overrides that might interfere with normal operation
        this.clearManualStyles();
        
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
          
        if (!activeMedia) {
          return;
        }
        
        // Ensure the target media is not hidden by manual styles
        activeMedia.style.display = '';
        activeMedia.classList.remove('hidden');
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        if (activeThumbnail) {
          this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
        }
        
        // Update navigation counter when media changes
        this.updateNavigationCounterFromActive();
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
